import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";

const GlobalNavLayout = lazy(() => import("../../components/GlobalNavLayout"));

const VirtualTradeshowBrandPage = withCompass(
  () => import("../../pages/VirtualTradeshowBrandPage")
);
const VirtualTradeshowPage = withCompass(
  () => import("../../pages/VirtualTradeshowPage")
);
const EditorialContentPage = withCompass(
  () => import("../../pages/EditorialContentPage")
);

export function CatWuRoutes() {
  return (
    <Switch>
      <Route
        exact
        path="/cwu/virtual-tradeshow"
        component={VirtualTradeshowPage}
      />
      <Route
        path="/cwu/virtual-tradeshow/brand/:brandSlug"
        component={VirtualTradeshowBrandPage}
      />
      <Route
        path="/cwu/editorial-content"
        render={() => (
          <GlobalNavLayout>
            <EditorialContentPage />
          </GlobalNavLayout>
        )}
      />
    </Switch>
  );
}

export const slug = "cwu";
